import { api } from '../helpers/api';
import utils from '../helpers/utils';

export const ACCOUNT_MODIFY_REQUEST = 'ACCOUNT_MODIFY_REQUEST';
export const ACCOUNT_MODIFY_SUCCESS = 'ACCOUNT_MODIFY_SUCCESS';
export const ACCOUNT_MODIFY_FAILURE = 'ACCOUNT_MODIFY_FAILURE';
export const ACCOUNT_CONTACT_PREF_GET_REQUEST = 'ACCOUNT_CONTACT_PREF_GET_REQUEST';
export const ACCOUNT_CONTACT_PREF_GET_SUCCESS = 'ACCOUNT_CONTACT_PREF_GET_SUCCESS';
export const ACCOUNT_CONTACT_PREF_GET_FAILURE = 'ACCOUNT_CONTACT_PREF_GET_FAILURE';
export const ACCOUNT_CONTACT_PREF_UPDATE_REQUEST = 'ACCOUNT_CONTACT_PREF_UPDATE_REQUEST';
export const ACCOUNT_CONTACT_PREF_UPDATE_SUCCESS = 'ACCOUNT_CONTACT_PREF_UPDATE_SUCCESS';
export const ACCOUNT_CONTACT_PREF_UPDATE_FAILURE = 'ACCOUNT_CONTACT_PREF_UPDATE_FAILURE';
export const ACCOUNT_CLEAR_STATUS = 'ACCOUNT_CLEAR_STATUS';

function accountModifyRequest() {
  return {
    type: ACCOUNT_MODIFY_REQUEST,
  };
}

function accountModifySuccess(payload) {
  return {
    type: ACCOUNT_MODIFY_SUCCESS,
    payload
  };
}

function accountModifyFailure(error) {
  return {
    type: ACCOUNT_MODIFY_FAILURE,
    error,
  };
}

export function accountModifyRecord(rec, accountId) {
  let url = utils.getModifyAccountPath();
  const config = {
    method: rec.method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': utils.getCookieValue(document.cookie, 'XSRF-TOKEN'),
      'account_id': accountId,
      'client_id': 'cct'
    },
    credentials: 'include',
    body: JSON.stringify(rec.body),
  };
  return api(url, config, accountModifyRequest(), accountModifySuccess, accountModifyFailure);
}

export function accountClearStatus() {
  return {
    type: ACCOUNT_CLEAR_STATUS,
  };
}

function acctContactPrefGetRequest(origin) {
  return {
    type: ACCOUNT_CONTACT_PREF_GET_REQUEST,
    origin
  };
}

function acctContactPrefGetSuccess(payload) {
  return {
    type: ACCOUNT_CONTACT_PREF_GET_SUCCESS,
    payload
  };
}

function acctContactPrefGetFailure(error) {
  return {
    type: ACCOUNT_CONTACT_PREF_GET_FAILURE,
    error,
  };
}

function acctContactPrefUpdateRequest(origin) {
  return {
    type: ACCOUNT_CONTACT_PREF_UPDATE_REQUEST,
    origin
  };
}

function acctContactPrefUpdateSuccess(payload) {
  return {
    type: ACCOUNT_CONTACT_PREF_UPDATE_SUCCESS,
    payload
  };
}

function acctContactPrefUpdateFailure(error) {
  return {
    type: ACCOUNT_CONTACT_PREF_UPDATE_FAILURE,
    error,
  };
}

export function accountContactPreferences(rec, accountId) {
  let url = utils.getContactPreferencesPath();

  const config = {
    method: rec.method ? rec.method : 'get',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'client_id': 'cct'
    },
    credentials: 'include'
  };
  if (accountId) {
    config.headers['account_id'] = accountId;
  }
  if (rec.method === 'post') {
    config.body = JSON.stringify(rec.body);
    return api(url, config, acctContactPrefUpdateRequest(rec.origin), acctContactPrefUpdateSuccess, acctContactPrefUpdateFailure);
  }
  return api(url, config, acctContactPrefGetRequest(rec.origin), acctContactPrefGetSuccess, acctContactPrefGetFailure);
}




// WEBPACK FOOTER //
// ./src/actions/account.js